(function () {
  let registry = window.__vxcRegistry || (window.__vxcRegistry = []);
  let swiperPromise = null;

  function loadStylesheet(href) {
    return new Promise(function (resolve, reject) {
      let existing = document.querySelector('link[data-vx-swiper-css="' + href + '"]');
      if (existing) {
        if (existing.getAttribute('data-vx-loaded') === '1' || existing.sheet) {
          resolve();
          return;
        }
        existing.addEventListener('load', function () {
          resolve();
        });
        existing.addEventListener('error', reject);
        return;
      }
      let el = document.createElement('link');
      el.rel = 'stylesheet';
      el.href = href;
      el.media = 'screen';
      el.setAttribute('data-vx-swiper-css', href);
      el.addEventListener('load', function () {
        el.setAttribute('data-vx-loaded', '1');
        resolve();
      });
      el.addEventListener('error', reject);
      document.head.appendChild(el);
    });
  }

  function loadScript(src) {
    window.__vxScripts = window.__vxScripts || {};
    if (!window.__vxScripts[src]) {
      window.__vxScripts[src] = new Promise(function (resolve, reject) {
        let existing = document.querySelector('script[data-vx-swiper-js="' + src + '"]');
        if (existing) {
          if (existing.getAttribute('data-vx-loaded') === '1') {
            resolve();
            return;
          }
          existing.addEventListener('load', function () {
            resolve();
          });
          existing.addEventListener('error', reject);
          return;
        }
        let el = document.createElement('script');
        el.src = src;
        el.defer = true;
        el.setAttribute('data-vx-swiper-js', src);
        el.addEventListener('load', function () {
          el.setAttribute('data-vx-loaded', '1');
          resolve();
        });
        el.addEventListener('error', reject);
        document.head.appendChild(el);
      });
    }
    return window.__vxScripts[src];
  }

  function ensureSwiper(jsSrc, cssSrc) {
    if (window.Swiper) return Promise.resolve(window.Swiper);
    if (!jsSrc) return Promise.reject(new Error('Missing Swiper src'));
    if (!swiperPromise) {
      swiperPromise = (cssSrc ? loadStylesheet(cssSrc) : Promise.resolve())
        .then(function () {
          return loadScript(jsSrc);
        })
        .then(function () {
          return window.Swiper;
        });
    }
    return swiperPromise;
  }

  function whenNear(el) {
    return new Promise(function (resolve) {
      if (window.Shopify && Shopify.designMode) {
        resolve();
        return;
      }
      if (!('IntersectionObserver' in window)) {
        resolve();
        return;
      }
      let io = new IntersectionObserver(
        function (entries) {
          for (let i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              io.disconnect();
              resolve();
              return;
            }
          }
        },
        { rootMargin: '200px 0px' }
      );
      io.observe(el);
    });
  }

  function unregister(root) {
    for (let i = registry.length - 1; i >= 0; i--) {
      if (registry[i].root === root) {
        if (registry[i].destroy) registry[i].destroy();
        registry.splice(i, 1);
      }
    }
  }

  function syncBuyLink(instance) {
    if (!instance || !instance.el) return;
    let pane = instance.el.closest('.vx-col__pane');
    if (!pane) return;
    let btn = pane.querySelector('[data-vx-col-buy]');
    let notify = pane.querySelector('[data-vx-col-notify]');
    let slide = instance.slides && instance.slides[instance.activeIndex];
    let href = slide ? slide.getAttribute('data-vx-slide-link') || '' : '';
    if (!href && btn) href = btn.getAttribute('data-vx-col-buy-fallback') || '';
    if (href && btn) {
      if (btn.getAttribute('href') !== href) btn.setAttribute('href', href);
      if (btn.hasAttribute('hidden')) btn.removeAttribute('hidden');
      if (notify && !notify.hasAttribute('hidden')) notify.setAttribute('hidden', '');
    } else {
      if (btn && !btn.hasAttribute('hidden')) btn.setAttribute('hidden', '');
      if (notify && notify.hasAttribute('hidden')) notify.removeAttribute('hidden');
    }
  }

  function initPopup(shell) {
    if (!shell) return null;
    let popup = shell.querySelector('[data-vx-col-popup]');
    if (!popup || popup.getAttribute('data-vx-col-popup-ready') === '1') return null;
    popup.setAttribute('data-vx-col-popup-ready', '1');

    let openBtns = Array.prototype.slice.call(shell.querySelectorAll('[data-vx-col-open-popup]'));
    let closeEls = Array.prototype.slice.call(popup.querySelectorAll('[data-vx-col-popup-close]'));
    let form = popup.querySelector('.vx-col-popup__form');
    let submitBtn = popup.querySelector('[data-vx-col-popup-submit]');
    let submitLabel = submitBtn ? submitBtn.querySelector('.vx-col-popup__submit-label') : null;
    let statusEl = popup.querySelector('[data-vx-col-popup-status]');
    let productValue = popup.querySelector('[data-vx-col-product-value]');
    let isOpen = false;
    let lastOpener = null;
    let scrollLocked = false;
    let submitting = false;
    let panel = popup.querySelector('.vx-col-popup__panel');

    // Do not set overflow:hidden on html/body — that breaks the sticky header.
    function onScrollAttempt(e) {
      if (!scrollLocked) return;
      e.preventDefault();
    }

    function lockPopupScroll() {
      if (scrollLocked) return;
      scrollLocked = true;
      document.addEventListener('wheel', onScrollAttempt, { passive: false, capture: true });
      document.addEventListener('touchmove', onScrollAttempt, { passive: false, capture: true });
    }

    function unlockPopupScroll() {
      if (!scrollLocked) return;
      scrollLocked = false;
      document.removeEventListener('wheel', onScrollAttempt, { capture: true });
      document.removeEventListener('touchmove', onScrollAttempt, { capture: true });
    }

    function focusEl(el) {
      if (!el || typeof el.focus !== 'function') return;
      try {
        el.focus({ preventScroll: true });
      } catch (err) {
        el.focus();
      }
    }

    function openPopup(opener) {
      if (isOpen) return;
      isOpen = true;
      lastOpener = opener || null;
      if (productValue) {
        productValue.value = (opener && opener.getAttribute('data-vx-col-product')) || '';
      }
      popup.removeAttribute('hidden');
      popup.setAttribute('aria-hidden', 'false');
      lockPopupScroll();
      focusEl(popup.querySelector('.vx-col-popup__close'));
    }

    function closePopup() {
      if (!isOpen) return;
      isOpen = false;
      popup.setAttribute('hidden', '');
      popup.setAttribute('aria-hidden', 'true');
      unlockPopupScroll();
      focusEl(lastOpener);
      lastOpener = null;
    }

    function setStatus(message, isError) {
      if (!statusEl) return;
      if (!message) {
        statusEl.setAttribute('hidden', '');
        statusEl.textContent = '';
        statusEl.classList.remove('is-error', 'is-success');
        return;
      }
      statusEl.hidden = false;
      statusEl.removeAttribute('hidden');
      statusEl.textContent = message;
      statusEl.classList.toggle('is-error', !!isError);
      statusEl.classList.toggle('is-success', !isError);
    }

    function resetSubmitButton() {
      if (!submitBtn || !submitLabel) return;
      submitBtn.disabled = false;
      submitBtn.removeAttribute('aria-busy');
      submitLabel.textContent = submitBtn.getAttribute('data-label') || 'Notify Me';
    }

    function onFormSubmit(e) {
      e.preventDefault();
    }

    function onSubmitClick(e) {
      e.preventDefault();
      if (!form || submitting) return;

      let nameInput = form.elements.name;
      let emailInput = form.elements.email;
      let name = nameInput && nameInput.value ? nameInput.value.trim() : '';
      let email = emailInput && emailInput.value ? emailInput.value.trim() : '';
      let product = productValue && productValue.value ? productValue.value.trim() : '';

      setStatus('');

      if (!name) {
        setStatus('Please enter your name.', true);
        if (nameInput) focusEl(nameInput);
        return;
      }
      if (!email || (typeof emailInput.checkValidity === 'function' && !emailInput.checkValidity())) {
        setStatus('Please enter a valid email.', true);
        if (emailInput) focusEl(emailInput);
        return;
      }

      let webhook = shell.getAttribute('data-vx-col-sheets-url') || '';
      if (!webhook) {
        setStatus('Google Sheet URL is not configured.', true);
        return;
      }

      submitting = true;
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.setAttribute('aria-busy', 'true');
      }

      let payload = new FormData();
      payload.append('name', name);
      payload.append('email', email);
      payload.append('product', product);

      // Fire-and-forget: Google Apps Script responses are slow; don't wait on them.
      try {
        if (navigator.sendBeacon) {
          navigator.sendBeacon(webhook, payload);
        } else {
          fetch(webhook, {
            method: 'POST',
            mode: 'no-cors',
            body: payload,
            keepalive: true
          }).catch(function () {});
        }
      } catch (err) {
        fetch(webhook, {
          method: 'POST',
          mode: 'no-cors',
          body: payload,
          keepalive: true
        }).catch(function () {});
      }

      form.reset();
      if (productValue && lastOpener) {
        productValue.value = lastOpener.getAttribute('data-vx-col-product') || '';
      }
      if (submitLabel) submitLabel.textContent = 'Submitted';
      setStatus('Thank you! We will notify you.', false);
      submitting = false;

      window.setTimeout(function () {
        resetSubmitButton();
        setStatus('');
        closePopup();
      }, 600);
    }

    function onOpenClick(e) {
      e.preventDefault();
      // Stop this click from also counting as an outside click that would close immediately
      e.stopPropagation();
      openPopup(e.currentTarget);
    }

    function onCloseClick(e) {
      e.preventDefault();
      closePopup();
    }

    function onKeydown(e) {
      if (!isOpen) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        closePopup();
      }
    }

    function onDocClick(e) {
      if (!isOpen) return;

      if (panel && panel.contains(e.target)) return;

      // Click anywhere else on the page (overlay, header, content) closes the popup
      closePopup();
    }

    if (form) form.addEventListener('submit', onFormSubmit);
    if (submitBtn) submitBtn.addEventListener('click', onSubmitClick);
    openBtns.forEach(function (btn) {
      btn.addEventListener('click', onOpenClick);
    });
    closeEls.forEach(function (el) {
      el.addEventListener('click', onCloseClick);
    });
    document.addEventListener('keydown', onKeydown);
    document.addEventListener('click', onDocClick);

    return {
      destroy: function () {
        closePopup();
        if (form) form.removeEventListener('submit', onFormSubmit);
        if (submitBtn) submitBtn.removeEventListener('click', onSubmitClick);
        openBtns.forEach(function (btn) {
          btn.removeEventListener('click', onOpenClick);
        });
        closeEls.forEach(function (el) {
          el.removeEventListener('click', onCloseClick);
        });
        document.removeEventListener('keydown', onKeydown);
        document.removeEventListener('click', onDocClick);
        popup.removeAttribute('data-vx-col-popup-ready');
      }
    };
  }

  function init(root) {
    if (!root || root.dataset.vxInit) return;
    root.dataset.vxInit = '1';

    let sectionId = root.dataset.vxColId || '';
    let host = root.closest('[data-vx-swiper-js]') || root.parentElement;
    let swiperJs = host ? host.getAttribute('data-vx-swiper-js') : '';
    let swiperCss = host ? host.getAttribute('data-vx-swiper-css') : '';
    let tabs = Array.prototype.slice.call(root.querySelectorAll('.vx-col__tab'));
    let panes = Array.prototype.slice.call(root.querySelectorAll('.vx-col__pane'));
    let swipers = [];
    let cancelled = false;
    let popupCtl = initPopup(host);

    function activate(id) {
      tabs.forEach(function (t) {
        let on = t.dataset.target === id;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panes.forEach(function (p) {
        let on = p.id === id;
        p.classList.toggle('is-active', on);
        if (on) p.removeAttribute('hidden');
        else p.setAttribute('hidden', '');
      });
      swipers.forEach(function (instance) {
        if (instance && instance.update) instance.update();
      });
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        if (!t.classList.contains('is-active')) activate(t.dataset.target);
      });
    });

    function onBlockSelect(e) {
      if (!e.detail || e.detail.sectionId !== sectionId) return;
      activate('vx-col-' + e.detail.blockId);
    }

    document.addEventListener('shopify:block:select', onBlockSelect);

    let delay = parseInt(root.dataset.delay, 10) || 3000;

    whenNear(root)
      .then(function () {
        if (cancelled) return;
        return ensureSwiper(swiperJs, swiperCss);
      })
      .then(function (SwiperCtor) {
        if (cancelled || !SwiperCtor) return;
        root.querySelectorAll('.vx-col__swiper').forEach(function (el) {
          let n = el.querySelectorAll('.swiper-slide').length;
          let instance = new SwiperCtor(el, {
            observer: true,
            observeParents: true,
            direction: 'horizontal',
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 1200,
            effect: 'slide',
            grabCursor: n > 1,
            allowTouchMove: n > 1,
            loop: n > 1,
            autoplay: n > 1 ? { delay: delay, disableOnInteraction: false } : false,
            on: {
              init: function () {
                syncBuyLink(this);
              },
              slideChange: function () {
                syncBuyLink(this);
              }
            }
          });
          swipers.push(instance);
          syncBuyLink(instance);
        });
      })
      .catch(function () {});

    function destroy() {
      cancelled = true;
      document.removeEventListener('shopify:block:select', onBlockSelect);
      if (popupCtl && popupCtl.destroy) popupCtl.destroy();
      popupCtl = null;
      swipers.forEach(function (instance) {
        if (instance && instance.destroy) instance.destroy(true, true);
      });
      swipers = [];
    }

    unregister(root);
    registry.push({ root: root, destroy: destroy });
  }

  function boot(scope) {
    let roots = (scope || document).querySelectorAll('[data-vx-col]');
    for (let i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    let section = event.target;
    if (!section || !section.querySelector) return;
    let root = section.querySelector('[data-vx-col]');
    if (!root) return;
    unregister(root);
    delete root.dataset.vxInit;
    init(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    let scope = event.target;
    if (!scope) return;
    let el =
      scope.matches && scope.matches('[data-vx-col]')
        ? scope
        : scope.querySelector && scope.querySelector('[data-vx-col]');
    if (el) unregister(el);
  });
})();

